import { SharedRegionConfig } from 'config/types';

export const sharedDevAuEnv: SharedRegionConfig = {
  streamAppKey: '38zxsbfneg6e',
};
